import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface RouteProps {
  children: JSX.Element;
}

export function PrivateRoute({ children }: RouteProps): JSX.Element {
  const { militar } = useAuth();
  const { state } = useLocation();

  if (!militar) {
    return <Navigate to="/" state={state} />;
  }

  return children;
}
